// Lives in a .ts file so Fast Refresh isn't invalidated by mixed exports in the .tsx Provider.
import { createContext } from 'react';

export interface Theme {
  id: string;
  name: string;
}

export const themes: Theme[] = [
  { id: 'light', name: 'Light' },
  { id: 'dark', name: 'Dark' },
  { id: 'system', name: 'System' },
];

export interface ThemeContextValue {
  currentTheme: Theme;
  resolvedTheme: 'light' | 'dark';
  setTheme: (themeId: string) => void;
  themes: Theme[];
}

export const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);
